import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API = 'https://api.sm-media.id';

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '', artist_name: '', referral_code: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [refValid, setRefValid] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    if (ref) setForm(f => ({ ...f, referral_code: ref.toUpperCase() }));
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/register`, form);
      navigate('/login?registered=true');
    } catch (err) {
      setError(err.response?.data?.error || 'Registrasi gagal');
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { key: 'name', label: 'Nama Lengkap', type: 'text', placeholder: 'Nama kamu', required: true },
    { key: 'artist_name', label: 'Nama Artis/Channel', type: 'text', placeholder: 'Nama artis atau channel YouTube', required: true },
    { key: 'email', label: 'Email', type: 'email', placeholder: 'email@kamu.com', required: true },
    { key: 'phone', label: 'No. WhatsApp', type: 'tel', placeholder: '08xxxxxxxxxx', required: false },
    { key: 'password', label: 'Password', type: 'password', placeholder: 'Min 6 karakter', required: true },
  ];

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
      background: 'linear-gradient(135deg, #0a0e1a 0%, #111827 100%)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: 440,
        background: '#111827',
        border: '1px solid #1e2d45',
        borderRadius: 16,
        padding: 32
      }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 24 }}>
          <span style={{ fontSize: 32, fontWeight: 700, background: 'linear-gradient(135deg, #f59e0b, #fbbf24)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>SM</span>
          <span style={{ fontSize: 14, fontWeight: 600, color: '#94a3b8', letterSpacing: 3 }}>MEDIA</span>
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#f1f5f9', marginBottom: 4 }}>Daftar Akun</h1>
        <p style={{ fontSize: 14, color: '#94a3b8', marginBottom: 28 }}>Mulai distribusi konten otomatis</p>

        {error && (
          <div style={{ background: '#450a0a', border: '1px solid #ef4444', color: '#ef4444', padding: '10px 14px', borderRadius: 8, fontSize: 14, marginBottom: 16 }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} autoComplete="on">
          {fields.map(f => (
            <div key={f.key} style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#94a3b8', marginBottom: 6 }}>
                {f.label} {f.required && <span style={{ color: '#ef4444' }}>*</span>}
              </label>
              <input
                type={f.type}
                placeholder={f.placeholder}
                value={form[f.key]}
                onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                required={f.required}
                style={{ fontSize: 16 }}
              />
            </div>
          ))}

          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#94a3b8', marginBottom: 6 }}>
              Kode Referral <span style={{ fontSize: 11, color: '#64748b' }}>(opsional)</span>
            </label>
            <input
              type="text"
              placeholder="Masukkan kode referral..."
              value={form.referral_code}
              onChange={e => setForm({ ...form, referral_code: e.target.value.toUpperCase() })}
              style={{ fontSize: 14, textTransform: 'uppercase' }}
            />
            {form.referral_code && (
              <div style={{ fontSize: 11, color: '#10b981', marginTop: 4 }}>
                🎉 Kode referral akan memberikan diskon untuk plan pertama kamu!
              </div>
            )}
          </div>
          <button
            type="submit"
            className="btn btn-gold"
            style={{ width: '100%', marginTop: 8, padding: 14, fontSize: 16 }}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Daftar Sekarang'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#94a3b8' }}>
          Sudah punya akun? <Link to="/login" style={{ color: '#f59e0b', textDecoration: 'none', fontWeight: 500 }}>Login</Link>
        </p>
      </div>
    </div>
  );
}
